export const PREBUILT_THEMES = [
    {
        primaryColor: '#FB9400',
        accentColor: '#FFD300',
        theme: 'default-theme'
    }
]